var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcknowledgementStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66657 10.31C5.54464 10.6337 5.00822 10.6337 4.88635 10.31C4.53279 9.3701 3.95358 8.08795 3.20918 7.34354C2.4648 6.59912 1.18258 6.01983 0.242923 5.66636C-0.0809746 5.54443 -0.0809746 5.00806 0.242923 4.88613C1.18258 4.53265 2.4648 3.95336 3.20918 3.20895C3.95358 2.46454 4.53279 1.18239 4.88635 0.242785C5.00822 -0.0811684 5.54464 -0.0811684 5.66657 0.242785C6.02004 1.18239 6.59933 2.46454 7.34374 3.20895C8.08814 3.95336 9.37028 4.53265 10.3102 4.88613C10.6338 5.00806 10.6338 5.54443 10.3102 5.66636C9.37028 6.01983 8.08814 6.59912 7.34374 7.34354C6.59933 8.08795 6.02004 9.3701 5.66657 10.31Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcknowledgementStarIcon);
export default __webpack_public_path__ + "static/media/acknowledgement-star-icon.f6888a290037f6edb74bf93bcc1a5c6f.svg";
export { ForwardRef as ReactComponent };